<!--
Considera pedidos de venda válidos (aberto ou faturado) pela data do pedido agrupado por produto
-->


<template>
  <div class="default-container p-3">
    <filtro :showfiltro="showfiltro" :params="paramsFiltro" @change="filtroChange" @cancel="showfiltro=false"></filtro>

    <div class="row">
      <div class="col-12 lbl-deal-title mb-2">
          <span class="lbl-deal-title mb-2 w-100">PEDIDOS POR PRODUTO</span>
          <v-button label="Retornar para visões" icon="fa-bar-chart" class="float-right" @click="clickRetornar"></v-button>
      </div>
    </div>
    <hr />
    <div class="row mb-3 align-items-center">
      <div class="col-md-6 col-12">
        <v-button label="Filtro" :success="true" @click="handleShowFiltro"></v-button>
      </div>
    </div>
    <div class="row">
      <div class="col-12 lbl-title mb-2">
        PRODUTOS E PEDIDOS
        <v-button label="Excel" class="float-right" @click="loadData(true)"></v-button>
        <!-- <v-button label="Imprimr" class="float-right"></v-button> -->
      </div>
    </div>

    <div class="row mb-5">
      <div class="col-12">
        <div style="width: 100%; max-height: 100%; overflow: hidden; font-size: 12px">
          <div style="overflow: auto">
            <div v-if="!dados || dados.length == 0" class="mb-5">
              <h6>Não há vendas para o período</h6>
            </div>
            <div v-for="(produto, index) in dados" :key="index" class="mb-5">
              <h6>{{ produto.produto_descricao }}</h6>
              <table class="table table-striped table-hover responsive tablesorter w-100">
                  <thead>
                      <tr>
                        <template v-for="col in colunas">
                          <th v-if="col.visible" :class="col.class" :style="col.style">{{ col.label }}</th>
                        </template>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-for="(row, index) in produto.pedidos" :key="index">
                          <td v-if="colunas[0].visible" class="">{{ row.npedido }}</td>
                          <td v-if="colunas[1].visible" class="">{{ row.data | formatData }}</td>
                          <td v-if="colunas[2].visible" class="">{{ row.nome_cliente }}</td>
                          <td v-if="colunas[3].visible" class="">{{ row.nome_usuario }}</td>
                          <td v-if="colunas[4].visible" class="numerico">{{ row.quantidade | formatValue(2) }}</td>
                          <td v-if="colunas[5].visible" class="numerico">{{ row.preco_sem_imposto | formatValue(2) }}</td>
                          <td v-if="colunas[6].visible" class="numerico">{{ row.total_com_imposto | formatValue(2) }}</td>
                          <td v-if="colunas[7].visible" class="numerico">{{ row.total_sem_imposto | formatValue(2) }}</td>
                      </tr>
                  </tbody>
                  <tfoot>
                      <tr>
                          <th class="text-right total">Total</th>
                          <th class="total" style=""></th>
                          <th class="total" style=""></th>
                          <th class="total" style=""></th>
                          <th class="numerico size130 total">{{ produto.quantidade | formatValue(2) }}</th>
                          <th class="numerico size130 total">{{ produto.preco_sem_imposto | formatValue(2) }}</th>
                          <th class="numerico size130 total">{{ produto.total_com_imposto | formatValue(2) }}</th>
                          <th class="numerico size130 total">{{ produto.total_sem_imposto | formatValue(2) }}</th>
                      </tr>
                  </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DashCard from "../dashboards/dash-card";
import Chart from "./chart";
import Filtro from "./filtro";
import { apiORDSpost, apiORDS } from "../shared/api-functions";
import { apiDownload2 } from "../shared/api-functions";

export default {
  components: {
    DashCard,
    Filtro,
    Chart,
  },

  data() {
    return {
      showfiltro: false,

      dados: {},
      dadosGrafico: null,

      //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA
      paramsFiltro: {

        periodo: {
          label: "Data da venda",
          varios: false,
          data_inicio: null,
          data_termino: null,
        },

        filtros: [
          {
            nome: "segmento",
            label: null,
            url: null,
            varios: true,
            values: [],
          },
          {
            nome: "grupocliente",
            label: null,
            url: null,
            varios: true,
            values: [],
          },
          {
            nome: "grupoestoque",
            label: null,
            url: null,
            varios: true,
            values: [],
          },
        ],
      },

      filtro: {
        periodos: [{ data_inicio: null, data_termino: null }],
      },

      colunas: [
      ],

      mounting: false,

    };
  },

  computed: {
    paramsChart: function () {
      return { chart: { type: "ColumnChart" }, values: this.chartValues, colors: this.colors }
    },

    chartValues: function () {
      if (!this.dadosGrafico || this.dadosGrafico.grafico.length == 0)
        return []
      else
        return this.dadosGrafico.grafico
    },
  },

  watch: {
      data_referencia: function () {
          this.loadData()
      },
  },

  methods: {
    clickRetornar () {
      this.$router.push('/')
    },

    montaColunas () {
        this.colunas = [
            { nome: 'pedido', visible: true, label: 'Número do Pedido', sortable: true, orderby: null, class: 'size130', style: '' },
            { nome: 'data', visible: true, label: 'Data do Pedido', sortable: true, orderby: null, class: 'size130', style: '' },
            { nome: 'cliente', visible: true, label: 'Cliente', sortable: true, orderby: null, class: '', style: 'width: 280px;' },
            { nome: 'usuario', visible: true, label: 'Usuario', sortable: true, orderby: null, class: '', style: 'width: 120px;' },
            { nome: 'preco_liquido', visible: true, label: 'Preço Unitário', sortable: true, orderby: null, class: 'numerico size130', style: '' },
            { nome: 'quantidade', visible: true, label: 'Quantidade', sortable: true, orderby: null, class: 'numerico size130', style: '' },
            { nome: 'total_sem_imposto', visible: true, label: 'Total', sortable: true, orderby: null, class: 'numerico size130', style: '' },
            { nome: 'total_com_imposto', visible: true, label: 'Total Com Imposto', sortable: true, orderby: null, class: 'numerico size130', style: '' },
        ]
    },

    handleShowFiltro() {
      this.showfiltro = true;
    },

    filtroChange(filtro) {
      this.showfiltro = false;

      this.filtro = filtro;

      this.paramsFiltro.filtros[0].values = this.filtro.segmento
      this.paramsFiltro.filtros[1].values = this.filtro.grupocliente
      this.paramsFiltro.filtros[2].values = this.filtro.grupoestoque

      this.loadData();
    },

    async loadData(excel) {

      let url = "consulta/vendas/vendaspedidosporproduto";
      // let url = "consulta/teste";

      this.filtro.excel = excel

      if (excel)
        apiDownload2(this, url, this.filtro, "post")
      else {
        const data = await apiORDSpost(this.$store, url, this.filtro, "post")
        // const data = await apiORDS(this.$store.getters.urlOrds + url)
        if (data) {
          this.dados = data.items;
        } else {
          this.dados = {};
        }
        this.montaColunas()
      }
    },
  },

  mounted() {

  },

  created() {
    this.filtro.periodos[0].data_inicio = this.$firstDay(this.$getDate())
    this.filtro.periodos[0].data_termino = this.$lastDay(this.$getDate())

    this.loadData()
  },
}


</script>

<style>

table .numerico {
  min-width: 65px;
  text-align: right;
}

table .size130 {
  min-width: 130px;
}

table .total {
    background: #c1c4c7;
    border: none;
}

table .var {
    min-width: 85px;
    text-align: center;
    background: #c1c4c7;
    display: inline-block;
}

table .var-negative {
    color: white;
    background: indianred;
}

table .var-positive {
    color: white;
    background: green;
}

table .border-left {
  border-left: 1px solid #dee2e6;
}

.resumo__performance {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.resumo__performance__value {
    padding: 5px 15px;
    font-size: 18px;
    font-weight: 600;
    text-align: left;
    border-radius: 10%;
}

</style>



// WEBPACK FOOTER //
// src/consultas/consulta-vendas-pedidos-produto.vue